import { ActivatedRoute } from '@angular/router';
import { Injectable, Injector } from '@angular/core';
import { ClickStreamService } from './click-stream.service';
import { HttpErrorResponse } from '@angular/common/http';
interface WyjatekWPrzegladarce {
  jsonType: string,
  url: string,
  wyjatek: string,
  stackTrace: string
}
const MAX = 9800;
const IGNOROWANY_STACK_TRACE = [
  "keyboard.o.checkClose",
  "TypeError: undefined is not an object (evaluating 'a.$el')",
  "t.keyboard/o.checkClose",
  "at o.checkClose"
];
@Injectable({
  providedIn: 'root'
})
export class WyjatekWPrzegladarceCSService {
  private collectData = false;
  private zarejestrowaneWyjatki = [];

  constructor(private injector: Injector) { }

  restart() {
    this.stop();
    this.start();
  }

  rejestrujWyjatek(exception, message = '') {
    if (!this.collectData || !exception)
      return;
    const activatedRoute: ActivatedRoute = this.injector.get(ActivatedRoute);
    const event: WyjatekWPrzegladarce = {
      jsonType: 'wyjatekWPrzegladarce',
      url: window.location.href,
      wyjatek: this.getNazwaWyjatku(exception, message),
      stackTrace: this.getStackTrace(exception)
    };
    if (!this.ignorowany(event) && !this.zarejestrowany(event)) {
      this.zarejestruj(event);
    }
  }

  private zarejestruj(event: WyjatekWPrzegladarce) {
    const clickStreamService: ClickStreamService = this.injector.get(ClickStreamService);
    clickStreamService.add(event);
    this.zarejestrowaneWyjatki.push(event.wyjatek);
  }

  private zarejestrowany(event: WyjatekWPrzegladarce): boolean {
    return this.zarejestrowaneWyjatki.filter(x => x === event.wyjatek).length > 0;
  }

  private start() {
    this.collectData = true;
  }

  private getNazwaWyjatku(exception, message) {
    if (exception instanceof HttpErrorResponse) {
      const httpErrorResponse = exception as HttpErrorResponse
      if (httpErrorResponse.error && httpErrorResponse.error.message)
        return httpErrorResponse.error.message;
      return httpErrorResponse.message;
    }
    return message + ' ' + exception.toString().substring(0, MAX)
  }
  private getStackTrace(exception): string {
    if (exception.stack)
      return exception.stack.substring(0, 10000);
    if (exception instanceof HttpErrorResponse) {
      const err = exception as HttpErrorResponse
      return err.message + ' ' + err.statusText + ' ' + err.status + ' ' + err.url;
    }
    return null;
  }

  private stop() {
    this.collectData = false;
  }
  private ignorowany(event: WyjatekWPrzegladarce): boolean {
    if (event.stackTrace) {
      return IGNOROWANY_STACK_TRACE.filter(x => event.stackTrace.includes(x)).length > 0;
    }
  }
}
